import { renderRadioButtonGroupFormItem } from "../../_components/SettingFormItems"
import { Radio } from "antd"
import { MiBOrderingModeEnum } from "../types"
import * as React from "react"
import { SettingFormItem } from "../../types"
import { WrappedFormUtils } from "antd/lib/form/Form"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"

type Props = {
    settings: SettingFormItem
    form: WrappedFormUtils
    onOrderingModeChange: (type: Maybe<string>) => void
}

export const OrderingModePickerSection = (props: Props) => {
    const radioStyle = {
        display: "block",
        height: "1.3rem",
        lineHeight: "1.3rem",
    }
    return (
        <div>
            {renderRadioButtonGroupFormItem(
                props.settings,
                "MIB_ORDERING_MODE",
                "",
                props.form,
                null,
                props.onOrderingModeChange,
                "radio-align-left",
                [
                    <div
                        key="delivery"
                        style={{
                            paddingBottom: "1rem",
                        }}>
                        <Radio
                            style={radioStyle}
                            value={MiBOrderingModeEnum.Delivery}
                            key={MiBOrderingModeEnum.Delivery}>
                            Delivery and/or Pickup
                        </Radio>
                        <div
                            style={{
                                position: "relative",
                                bottom: "0.1rem",
                                paddingLeft: "1.5rem",
                                paddingRight: "5rem",
                                lineHeight: "1.3",
                            }}>
                            <span
                                style={{
                                    fontSize: "12px",
                                    color: "#7E7E7E",
                                }}>
                                Select if your business sells physical goods, which need to be delivered or picked up by
                                the customer.
                            </span>
                        </div>
                    </div>,
                    <div
                        key="epurchase"
                        style={{
                            paddingBottom: "1rem",
                        }}>
                        <Radio
                            style={radioStyle}
                            value={MiBOrderingModeEnum.Epurchase}
                            key={MiBOrderingModeEnum.Epurchase}>
                            E-Purchase
                        </Radio>
                        <div
                            style={{
                                position: "relative",
                                bottom: "0.1rem",
                                paddingLeft: "1.5rem",
                                paddingRight: "5rem",
                                lineHeight: "1.3",
                            }}>
                            <span
                                style={{
                                    fontSize: "12px",
                                    color: "#7E7E7E",
                                }}>
                                Select if your business sells &#34;abstract&#34; goods, that do not need to be
                                physically delivered to the customer.
                            </span>
                        </div>
                    </div>,
                    <div key="dine-in">
                        <Radio style={radioStyle} value={MiBOrderingModeEnum.DineIn} key={MiBOrderingModeEnum.DineIn}>
                            Dine In
                        </Radio>
                        <div
                            style={{
                                position: "relative",
                                bottom: "0.1rem",
                                paddingLeft: "1.5rem",
                                paddingRight: "5rem",
                                lineHeight: "1.3",
                            }}>
                            <span
                                style={{
                                    fontSize: "12px",
                                    color: "#7E7E7E",
                                }}>
                                Select if your business sells only in physical space. Be aware, this option will
                                deactivate Pickup and Delivery
                            </span>
                        </div>
                    </div>,
                ]
            )}
        </div>
    )
}
